import { convertLayoutItem } from './common';
import { convertSimplifiedProjectChildItemResponse } from './projectChildItem';
import { FloorTypes, SimplifiedFloorTypes } from '../../types';
import {
  FloorLayoutResponseTypes,
  FloorResponseTypes,
  SimplifiedFloorResponseTypes,
} from '../../types/response';
import { FloorLayoutTypes } from '../../types/layout';
import { checkValidUrl } from '../shareLinkUtils';

export const convertFloorResponse = (item: FloorResponseTypes): FloorTypes => {
  const floor = convertSimplifiedFloorResponse(item);
  const { layoutItems = [], apartments = [] } = item;
  return {
    ...floor,
    overlayLayout: item.overlayLayout,
    items: apartments.map((i) => convertSimplifiedProjectChildItemResponse(i)),
    itemIds: apartments.map((i) => i.id),
    layoutImage: item.imageLayout,
    layoutItems: layoutItems.map((i) => convertFloorLayoutResponse(i)),
    isSimplified: false,
  };
};

export const convertFloorLayoutResponse = (item: FloorLayoutResponseTypes): FloorLayoutTypes => {
  const layout = convertLayoutItem(item);
  return {
    ...layout,
    id: `${item.floorId}_${item.itemId}`,
    floorId: item.floorId,
    projectChildItemId: item.itemId,
  };
};

export const convertSimplifiedFloorResponse = (
  item: SimplifiedFloorResponseTypes
): SimplifiedFloorTypes => ({
  id: item.id,
  alias: item.alias,
  code: item.code,
  name: item.name,
  floorNumber: `${item.floorNumber}`,
  totalApartments: item.totalApartments,
  isSimplified: true,
  isDisabled: !item.totalApartments,
  virtualTourUrl: checkValidUrl(item.virtualTourUrl) ? item.virtualTourUrl : undefined,
});
